const doc = [({"zh_cn":({"adminConstantHotelChildrenSearchDisplayType":({"all":"全部", "onlyAge":"只显示年龄", "onlyMealTypeAndBedding":"仅显示膳食/床上用品"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;